export default {
  Quote: 'Quote'
}
